import PermissionsService from '../runtime/services/PermissionsService';

class PermissionsHelper implements PermissionsProvider
{
    private permissions: Record<string, boolean>;

    public constructor()
    {
        this.permissions = {};
    }

    public purge()
    {
        this.permissions = {};
    }

    public async get(keys: string[], throwError: boolean = false)
    {
        const request: string[] = [];
        const result: Record<string, boolean> = {};

        for (let i = 0; i < keys.length; i++)
        {
            const key = keys[i];

            result[key] = this.permissions[key] || false;

            if (!(key in this.permissions))
                request.push(key);
        }

        if (request.length > 0)
        {
            try
            {
                const response = await PermissionsService.checkPermissions(request);

                Object.keys(response).forEach((key) =>
                {
                    this.permissions[key] = result[key] = response[key];
                });
            }
            catch (ex)
            {
                if (throwError)
                    throw ex;
            }
        }

        return result;
    }

    public async all(keys: string[], throwError: boolean = false)
    {
        const result = await this.get(keys, throwError);

        return Object.values(result).filter(value => value === false).length === 0;
    }

    public async any(keys: string[], throwError: boolean = false)
    {
        const result = await this.get(keys, throwError);

        return Object.values(result).filter(value => value === true).length > 0;
    }
}

export default defineNuxtPlugin({
    name: 'permissions',
    dependsOn: ['http'],
    async setup(nuxtApp)
    {
        return {
            provide: {
                permissions: new PermissionsHelper()
            }
        };
    }
});

declare module '@vue/runtime-core'
{
    interface ComponentCustomProperties
    {
        $permissions: Permissions;
    }
}
